import { Menu, MenuItem } from "@snapchat/snap-design-system";
import { type FC } from "react";
import { Visible } from "../../../common/components";
import { useModal } from "../../../core/hooks";
import { LenssourceModelLensSourceType as LensSourceType } from "../../../../gql-generated/types";
import { UpdateLensSourceContainer } from "../../container/UpdateLensSourceContainer";
import { AddLensSourceModal } from "../AddLensSourceModal";
import { defaultButtonStyle, SourceTypesDropdown } from "./AddLensSource.styles";
import { SourceMenuItem } from "./SourceMenuItem";

interface AddLensSourceProps {
    loading: boolean;
    types: readonly LensSourceType[];
    disabled: boolean;
    buttonClassName?: string;
}

export const AddLensSource: FC<AddLensSourceProps> = ({
    loading,
    types,
    disabled,
    buttonClassName = defaultButtonStyle,
}) => {
    const [modalProps, showModal, selectedType] = useModal<LensSourceType>();
    return (
        <>
            <SourceTypesDropdown
                overlay={
                    <Menu>
                        {types.map((lensSourceType) => (
                            <MenuItem key={lensSourceType}>
                                <SourceMenuItem key={lensSourceType} type={lensSourceType} onClick={showModal} />
                            </MenuItem>
                        ))}
                    </Menu>
                }
                buttonProps={{
                    type: "primary",
                    label: "Add Lens Source",
                    className: buttonClassName,
                    isPending: loading,
                }}
                isDisabled={disabled}
            />
            <Visible when={selectedType != null}>
                <UpdateLensSourceContainer selectedType={selectedType!}>
                    {({ enable, updating }) => (
                        <AddLensSourceModal
                            {...modalProps}
                            onAdd={enable}
                            enabling={updating}
                            selectedType={selectedType!}
                        />
                    )}
                </UpdateLensSourceContainer>
            </Visible>
        </>
    );
};
